export default __webpack_public_path__ + "static/media/totinella.0c6e8eaa.jpeg";